module.exports = __webpack_public_path__ + "img/gh.1d4ccacf.png";